import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    Output, TemplateRef, ViewChild, ViewEncapsulation
} from '@angular/core';
import { IMyDateModel, IMyOptions } from 'mydatepicker';
import { SchedulingSettingsDatepickerService } from '../../../../../payment/services/scheduling-settings-datepicker.service';
import { SchedulingSettingPeriod } from '../../../../../shared/models/scheduling-setting-period';
import { SchedulingSetting } from '../../../../../shared/models/scheduling-setting';
import { OrderDetails } from '../../../../models/orders/details';
import { OverlayContext } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CommonHttpService } from '../../../../../shared/services/http.service';
import { ClientModel } from '../../../../../shared/models/client.model';

@Component({
    selector: 'account-orders-details-actions-schedule',
    templateUrl: './account.orders.details.actions.schedule.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsActionsScheduleComponent implements AfterViewInit {
    @ViewChild('updateScheduleTemplateRef') public updateScheduleTemplateRef: TemplateRef<any>;
    @Input('client') client: ClientModel;
    @Input('order') order: OrderDetails;
    @Output('updated') updated: EventEmitter<any> = new EventEmitter();

    protected updateScheduleDialogOverlayContext = new OverlayContext();
    public loading = false;
    public possibleSchedulingSettings: Array<SchedulingSetting> = [];
    public deliveryDateModel: string;
    public periodModel: SchedulingSettingPeriod;
    public datePickerOptions: IMyOptions;


    constructor(
        protected modal: Modal,
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected toastr: ToastrService,
        protected schedulingSettingsDatepickerService: SchedulingSettingsDatepickerService
    ) {
        this.updateScheduleDialogOverlayContext.inElement = false;
        this.updateScheduleDialogOverlayContext.isBlocking = true;
        this.updateScheduleDialogOverlayContext.keyboard = null;
    }

    ngAfterViewInit() {
        this.schedulingSettingsDatepickerService
            .setSchedulingSettings(this.order.deliveries.zip_code_range.scheduling_settings);
        this.datePickerOptions = this.schedulingSettingsDatepickerService.buildDatePickerOptions();
    }

    /**
     * Open dialog to input payment method data.
     **/
    public openDialog() {
        this.modal
            .open(this.updateScheduleTemplateRef, {context: this.updateScheduleDialogOverlayContext})
            .then(() => {});
    }
    /**
     * Close dialog.
     **/
    public closeDialog(dialogReference: any) {
        dialogReference.close();
    }

    /**
     * Setting period model
     **/
    public choosePeriod(period: SchedulingSettingPeriod) {
        this.periodModel = period;
    }
    /**
     * Checking if informed period is the same as selected.
     **/
    public isChosenPeriod(period: SchedulingSettingPeriod) {
        return this.periodModel !== undefined
            && this.periodModel.id === period.id;
    }
    /**
     * Setting date model from IMyDateModel.
     **/
    public chooseDate(event: IMyDateModel) {
        this.deliveryDateModel = `${event.date.year}-${event.date.month}-${event.date.day}`;
        this.possibleSchedulingSettings = this.schedulingSettingsDatepickerService
            .definePossibleSchedulingSettings(this.deliveryDateModel);
    }
    /**
     * Checking if delivery date model and period model are both filled.
     **/
    public isReady() {
        return this.deliveryDateModel !== undefined
            && this.periodModel !== undefined;
    }
    /**
     * Call API to update order schedule data.
     **/
    public save(dialogReference: any) {
        this.loading = true;
        this.http.useAuth().put(
            `/account/clients/${this.client.id}/orders/${this.order.id}`,
            {
                'schedule': {
                    'date': this.deliveryDateModel,
                    'period_id': this.periodModel.id
                }
            }
        ).subscribe(() => {
            this.closeDialog(dialogReference);
            this.updated.emit();

            this.loading = false;
            this.translate
                .get('ACCOUNT.ORDERS.DETAILS.ACTIONS.UPDATE_SCHEDULE_MODAL.SUCCESS')
                .subscribe(message => this.toastr.success(message));
        }, () => {
            this.loading = false;
            this.translate
                .get('ACCOUNT.ORDERS.DETAILS.ACTIONS.UPDATE_SCHEDULE_MODAL.ERROR')
                .subscribe(message => this.toastr.error(message));
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/account/orders/details/actions/schedule/account.orders.details.actions.schedule.component.ts